export default __webpack_public_path__ + "static/media/dpd-logo.27b60313.jpeg";